// src/components/Medicine/MedicineByCategory.js
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addItem, removeItem } from "../../Redux/CartSlice";
import { updateCartOnServer } from "../../services/Cart/CartPage"; 
import { fetchMedicineByCategory } from "../../services/HomePage/MedicineByCategoryApi";

export default function MedicineByCategory({ categoryId, onClose }) {
  const [medicines, setMedicines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const reduxCart = useSelector((state) => state.cart.items);

  // Panel open animation
  useEffect(() => {
    setTimeout(() => setOpen(true), 50);
  }, []);

  // Fetch medicines by category
  useEffect(() => {
    const load = async () => {
      try {
        const data = await fetchMedicineByCategory(categoryId);
        setMedicines(Array.isArray(data) ? data : []);
      } catch (e) {
        setError("Failed to load medicines");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [categoryId]);

  // Close panel
  const closePanel = () => {
    setOpen(false);
    setTimeout(onClose, 300);
  };

  // ================= CART FUNCTIONS =================
  const getCartQty = (medicineId) => {
    return reduxCart.find((i) => i.productId === medicineId && i.categoryId === 1)?.quantity || 0;
  };

  const handleAdd = async (med) => {
    try {
      await updateCartOnServer({
        productId: med.id,
        categoryId: 1,
        quantity: 1,
        price: med.salePrice,
      });

      dispatch(
        addItem({
          productId: med.id,
          categoryId: 1,
          name: med.name,
          price: med.salePrice,
          quantity: 1,
        })
      );
    } catch (err) {
      console.error("Add to cart failed", err);
    }
  };

  const handleRemove = async (med) => {
    try {
      await updateCartOnServer({
        productId: med.id,
        categoryId: 1,
        quantity: -1,
        price: med.salePrice,
      });

      dispatch(
        removeItem({
          productId: med.id,
          categoryId: 1,
          quantity: 1,
        })
      );
    } catch (err) {
      console.error("Remove from cart failed", err);
    }
  };

  return (
    <>
      {/* Overlay */}
      <div
        onClick={closePanel}
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.5)",
          zIndex: 1040,
        }}
      />

      {/* Right Panel */}
      <div
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          width: "420px",
          maxWidth: "90%",
          height: "100vh",
          background: "#fff",
          overflowY: "auto",
          boxShadow: "-2px 0 10px rgba(0,0,0,0.2)",
          zIndex: 1050,
          transform: open ? "translateX(0)" : "translateX(100%)",
          transition: "transform 0.3s ease",
        }}
      >
        <div className="d-flex justify-content-between p-3 border-bottom">
          <h5 className="fw-bold m-0">Medicines</h5>
          <button className="btn btn-sm btn-outline-danger" onClick={closePanel}>
            X
          </button>
        </div>

        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-danger"></div>
          </div>
        ) : error ? (
          <h4 className="text-center text-danger py-5">{error}</h4>
        ) : medicines.length === 0 ? (
          <p className="text-center py-5 text-muted">No medicines found.</p>
        ) : (
          <div className="p-3">
            {medicines.map((med) => {
              const qty = getCartQty(med.id);
              return (
                <div key={med.id} className="card mb-3 shadow-sm border-0">
                  <div className="row g-0 align-items-center">
                    <div className="col-4">
                      <img
                        src={med.image ? `https://www.online-tech.in/${med.image}` : "https://placehold.co/200x120"}
                        className="img-fluid ms-1"
                        style={{ height: "100px", width: "100%", objectFit: "cover" }}
                      />
                    </div>
                    <div className="col-8">
                      <div className="card-body py-2">
                        <h6 className="fw-bold text-truncate">{med.name}</h6>
                        {med.saltName && <div className="small text-muted">Salt: {med.saltName}</div>}
                        {med.strength && <div className="small text-muted">Strength: {med.strength}</div>}
                        {med.isPrescription !== undefined && (
                          <div className="small text-muted">
                            {med.isPrescription ? "Prescription Required" : "OTC"}
                          </div>
                        )}
                        {med.description && (
                          <div className="small text-truncate" title={med.description}>
                            {med.description}
                          </div>
                        )}

                        {/* Add / Quantity Buttons */}
                        {qty === 0 ? (
                          <button
                            className="btn btn-sm btn-danger mt-2 w-100 rounded-pill fw-semibold"
                            onClick={() => handleAdd(med)}
                          >
                            Add +
                          </button>
                        ) : (
                          <div className="d-flex justify-content-between align-items-center bg-light border rounded-pill px-2 mt-2">
                            <button onClick={() => handleRemove(med)} className="btn btn-sm text-danger fw-bold">–</button>
                            <span className="fw-bold">{qty}</span>
                            <button onClick={() => handleAdd(med)} className="btn btn-sm text-danger fw-bold">+</button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
}